export const defaultHeaders = ()=>{
    let headers = new Headers();
    headers.append('X-XSRF-TOKEN', document.getElementsByName("__RequestVerificationToken")[0].value);
    headers.append('content-type', 'application/json');
    return headers;
};
const defaultOptions = ()=>({
        credentials: 'include',
        headers: defaultHeaders()
    });
export const defaultGetOptions = ()=>({
        method: 'GET',
        ...defaultOptions()
    });
export const defaultPutOptions = ()=>({
        method: 'PUT',
        ...defaultOptions()
    });
export const defaultPostOptions = ()=>({
        method: 'POST',
        ...defaultOptions()
    });
export const handle = async (res)=>{
    if (400 <= res.status && res.status < 500) return {
        kind: 'unauthorized',
        status: res.status
    };
    if (res.status >= 500) return {
        kind: 'failed',
        status: res.status
    };
    const result = await res.json();
    return {
        kind: 'result',
        status: 200,
        value: result
    };
};
export const previousOrDefault = (asyncState, defaultValue)=>asyncState.kind == 'loaded' ? asyncState.value : defaultValue;
export const ready = (asyncState)=>asyncState.kind == 'loaded' || asyncState.kind == 'loading' && asyncState.value != null;
export const loading = (asyncState)=>asyncState.kind == 'loading' && asyncState.value == null;
export const transitionedToLoaded = (from, to)=>from.kind != 'loaded' && to.kind == 'loaded';
